.collapsedInformationContainer {
    display: flex;
    gap: 20px;
    margin-top: 20px;
}

.collapsedThirdPartyInformation {
    display: flex;
    flex-direction: column;
    flex: 1;

    /* Keeps third party width consistent when no service is present. */
    max-width: 50%;
}

.collapsedServiceInformation {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.collapsedInformationSeparator {    
    border-left: 1px solid rgba(224, 224, 224, 1);
    height: calc(100% - 10px);
}

/* Wraps the entire "details" section and renders children vertically. Copied from the centralized CSS for "details" pages. */
.detailsContainer {
    display: flex;
    flex-direction: column;
}

/* Renders multiple evenly-spaced columns. Immediate descendants should be of the `detailsGridColumn` class. Copied from the centralized CSS for "details" pages, minus the max-width configuration. */
.detailsGridSection {
    display: flex;
    justify-content: space-between;
}

/* Copied from the centralized CSS for "details" pages. */
.detailsGridColumn {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

/* This class should wrap any field label + field value pair in the "details" section. Standardizes spacing between children of the details container. Copied from the centralized CSS for "details" pages. */
.labelAndValueContainerOutsideOfGrid {
    margin-bottom: 20px;
}

.labelAndValueContainerInsideOfGrid {
    height: 52px;
    margin-bottom: 20px;
}